var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabSlasherMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 31,
    viewBox: "0 0 37 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 2.95544H31.625V20.7679H17.5625V24.5179H36.3125V20.7679H34.4375V0.142944H8.1875V7.64294H11V2.95544Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.6875 9.51794V30.1429H15.6875V9.51794H0.6875ZM3.5 12.3304V26.3929H12.875V12.3304H3.5Z",
    fill: "#BCB3D0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabSlasherMain);
export default __webpack_public_path__ + "static/media/tabSlasherMain.d860085ba64c24b9823e321b658b9a22.svg";
export { ForwardRef as ReactComponent };